import { render, staticRenderFns } from "./downstream.vue?vue&type=template&id=78bccf19&scoped=true&"
import script from "./downstream.vue?vue&type=script&lang=js&"
export * from "./downstream.vue?vue&type=script&lang=js&"
import style0 from "./downstream.vue?vue&type=style&index=0&id=78bccf19&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bccf19",
  null
  
)

export default component.exports